






import { Vue, Component } from "vue-property-decorator";
import totalDetail from "@/views/newPension/totalDetail/index.vue";
@Component({
  components: {
    totalDetail,
  },
})
export default class extends Vue {

}
